import { useCallback, useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory, generatePath } from 'react-router-dom'

import { useAppSelector } from 'app/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { CommonButton } from 'components/Button'
import ClaimHomeModal from 'features/jobs/components/ClaimHomeModal'
import { JobPageContext } from 'features/jobs/JobPageContext'
import ROUTES from 'app/routes'

import { jobInfoMessages } from '../messages'
import {
  JobAddHomeContainer,
  BlockTitle,
  BlockMsg,
  BlockMsgInner,
  CtaBtnContainer,
} from './styles'

function JobInfoAddHome() {
  const history = useHistory()
  const rootDomainId = useAppSelector(currentRootDomainIdSelector)
  const { jobName, jobId } = useContext(JobPageContext)
  const [isAddHomeOpen, setIsAddHomeOpen] = useState(false)

  const onClaimHomeSuccess = useCallback(
    ({ homeId }: { homeId: string }) => {
      if (rootDomainId) {
        history.replace(
          generatePath(ROUTES.homeStatus, { homeId, rootDomainId })
        )
      }
    },
    [history, rootDomainId]
  )

  return (
    <StyledFadeInWrapper>
      <JobAddHomeContainer>
        <BlockTitle>
          <FormattedMessage {...jobInfoMessages.addHomeTitle} />
        </BlockTitle>
        <BlockMsg>
          <BlockMsgInner>
            <FormattedMessage {...jobInfoMessages.addHomeMsg} />
          </BlockMsgInner>
        </BlockMsg>
        <CtaBtnContainer>
          <CommonButton
            variant="primary"
            onClick={() => setIsAddHomeOpen(!isAddHomeOpen)}
          >
            <FormattedMessage {...jobInfoMessages.addHomeBtn} />
          </CommonButton>
        </CtaBtnContainer>
      </JobAddHomeContainer>

      {isAddHomeOpen && (
        <ClaimHomeModal
          domainId={jobId}
          onClose={() => setIsAddHomeOpen(false)}
          onAddSuccess={onClaimHomeSuccess}
          jobName={jobName}
        />
      )}
    </StyledFadeInWrapper>
  )
}

export default JobInfoAddHome
